// extracted by mini-css-extract-plugin
export default {"mightOverflow":"FormComponents_mightOverflow__3c9yG","ellipsisPopup":"FormComponents_ellipsisPopup__cF9Hv","header":"FormComponents_header__YmM5h"};